import Rating from "./rating.molecule";

export default Rating;
